import React from "react";
import { Link } from "react-router-dom";
import { Play, Heart } from "lucide-react";

const CTA = () => {
  return (
    <section id="about" className="py-24 relative overflow-hidden">
      <div className="absolute inset-0 dotted-bg opacity-50" />
      <div className="relative max-w-5xl mx-auto px-6 lg:px-10 text-center">
        <div className="inline-flex items-center gap-2 text-[#ffcb05] mb-6">
          <Heart size={16} className="fill-current" />
          <span className="mono-pixel tracking-[0.3em] text-sm">PLAY · EARN · COLLECT</span>
          <Heart size={16} className="fill-current" />
        </div>

        <h2 className="pixel-font text-2xl sm:text-3xl lg:text-4xl text-white leading-snug mb-8">
          READY TO BEGIN<br/>YOUR <span className="text-[#ffcb05] glow-yellow">JOURNEY?</span>
        </h2>

        <p className="text-white/60 max-w-2xl mx-auto mb-10 leading-relaxed">
          No installs. No accounts. Just click play and step into a 2.5D world. 
          Your progress saves automatically to your browser — you can even install it as an app for offline play.
        </p>

        <div className="flex flex-wrap justify-center gap-4 mb-16">
          <Link to="/play" className="press-start pixel-font text-xs sm:text-sm px-8 py-4 rounded inline-flex items-center gap-3">
            <Play size={18} fill="currentColor" />
            PLAY NOW
          </Link>
          <a href="https://x.com/pokerealmsfun" target="_blank" rel="noreferrer" className="outline-btn px-7 py-4 rounded inline-flex items-center gap-2 text-sm">
            <span className="font-bold">𝕏</span> Follow @pokerealmsfun
          </a>
        </div>

        <div className="text-xs text-white/40 max-w-3xl mx-auto leading-relaxed border-t border-white/5 pt-8">
          <p>
            All creature designs and related media belong to their respective owners.
            PokéRealms is an independent project for educational and entertainment purposes only.
          </p>
        </div>
      </div>
    </section>
  );
};

export default CTA;
